import React, { useState, useEffect, memo } from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { Link } from 'react-router-dom';
import { ServerConfig } from 'config'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../redux/actions/auth.js'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import List from '../../components/EntryListAndEdit/List'
import PaginatedList from '../../components/PaginatedList/PaginatedList'
import FileUpload from '../PublicRelations/FileUpload.js'


import { getAllowedRoutes } from 'utils';
import _, { get } from 'lodash'

const evt = new Event('customertable_is_dirty');

const useStyles = makeStyles((theme) => ({}))

const NFCTokens = () => {
  const auth = useSelector(state => state.auth)
  const editable_fields = [
      ["id", "ID"],
      ["uid", "UID"],
      ["tenant_id", "Tenant ID", "tenant"],
      ["tenant_employee_id", "Tenant Employee ID"],
      ["password", "Password"],
      ["version", "Version"],
  ];
  const non_editable_fields = [
      ["created_ts", "Created"],
      ["last_changed_ts", "Changed"],
      ["assigned_to_tenant_ts", "Assigned Tenant"],
      ["assigned_to_tenant_employee_ts", "Assigned Tenant-Empl"],
    ];

  return (
    <>
        <PaginatedList
            list_get_url={`${ServerConfig.SERVER_URL}/nfctoken/`}
            detail_get_url={`${ServerConfig.SERVER_URL}/nfctoken/detail/`}
            detail_put_url={`${ServerConfig.SERVER_URL}/nfctoken/`}
            add_new_url={`${ServerConfig.SERVER_URL}/nfctoken/`}

            column_names={["id", "uid", "tenant_id", "tenant_employee_id"]}
            header_names={["ID", "UID", "Tenant ID", "Tenant Empl ID"]}

            optional_column_names={[]}
            optional_header_names={[]}

            editable_fields={editable_fields}
            non_editable_fields={non_editable_fields}
        />
    </>
  )
}

export default NFCTokens
